export default "__VITE_ASSET__0ab80ada__"